import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { api } from '../lib/api';

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [stage, setStage] = useState('email'); // email | code | done
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const handleSendCode = async (e) => {
    e.preventDefault();
    setError('');
    if (!email) { setError('Please enter your email'); return; }
    setLoading(true);
    try {
      const data = await api.forgotPassword(email);
      setMessage(data.message);
      setStage('code');
    } catch (e) {
      setError(e.message);
    }
    setLoading(false);
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setError('');
    if (!code || !newPassword) { setError('Please fill in all fields'); return; }
    if (newPassword.length < 8) { setError('Password must be at least 8 characters'); return; }
    setLoading(true);
    try {
      await api.resetPassword(email, code, newPassword);
      setStage('done');
    } catch (e) {
      setError(e.message);
    }
    setLoading(false);
  };

  const INPUT = { width: '100%', background: 'var(--pp-overlay)', border: '1px solid var(--pp-border)', color: 'var(--pp-text)', padding: '12px 14px', fontSize: '15px', outline: 'none', borderRadius: 0 };
  const LABEL = { display: 'block', fontSize: '10px', fontWeight: 600, letterSpacing: '0.18em', textTransform: 'uppercase', color: 'var(--pp-text-3)', marginBottom: '8px' };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--pp-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px 16px' }}>
      <div style={{ width: '100%', maxWidth: 420 }}>
        <button onClick={() => navigate('/')} style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'none', border: 'none', color: 'var(--pp-text-3)', fontSize: 13, cursor: 'pointer', marginBottom: 32 }}>
          <ArrowLeft size={16} /> Back to Sign In
        </button>

        <h1 style={{ fontSize: 24, fontWeight: 700, letterSpacing: '0.1em', marginBottom: 8 }}>RESET PASSWORD</h1>
        <p style={{ fontSize: 13, color: 'var(--pp-text-3)', marginBottom: 32 }}>
          Enter your email and we'll send the 6-digit reset code instantly.
        </p>

        {stage === 'email' && (
          <form onSubmit={handleSendCode}>
            <div style={{ marginBottom: 22 }}><label style={LABEL}>Email Address</label><input style={INPUT} type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="trader@example.com" /></div>
            {error && <p style={{ color: 'var(--pp-error)', fontSize: 13, marginBottom: 16 }}>{error}</p>}
            <button type="submit" className="btn-primary" style={{ width: '100%', height: 52 }} disabled={loading}>{loading ? 'SENDING...' : 'GET RESET CODE'}</button>
          </form>
        )}

        {stage === 'code' && (
          <form onSubmit={handleResetPassword}>
            {message && (
              <div style={{ background: 'rgba(41,121,255,0.08)', border: '1px solid rgba(41,121,255,0.3)', padding: 14, marginBottom: 20, borderRadius: 0 }}>
                <p style={{ margin: '0 0 6px', fontSize: 13, fontWeight: 700, color: '#2979FF' }}>✓ Reset code sent to your email</p>
                <p style={{ margin: 0, fontSize: 13, color: 'var(--pp-text-2)', lineHeight: 1.6 }}>
                  Check your inbox at <strong style={{ color: '#fff' }}>{email}</strong>. The code expires in 1 hour.
                </p>
              </div>
            )}
            <div style={{ marginBottom: 22 }}><label style={LABEL}>6-Digit Reset Code</label><input style={{ ...INPUT, textAlign: 'center', fontSize: 20, letterSpacing: '0.3em' }} type="text" value={code} onChange={e => setCode(e.target.value)} placeholder="000000" maxLength={6} /></div>
            <div style={{ marginBottom: 22 }}><label style={LABEL}>New Password</label><input style={INPUT} type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} placeholder="Min. 8 characters" /></div>
            {error && <p style={{ color: 'var(--pp-error)', fontSize: 13, marginBottom: 16 }}>{error}</p>}
            <button type="submit" className="btn-primary" style={{ width: '100%', height: 52 }} disabled={loading}>{loading ? 'RESETTING...' : 'RESET PASSWORD'}</button>
          </form>
        )}

        {stage === 'done' && (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
            <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 8 }}>Password Updated!</h2>
            <p style={{ color: 'var(--pp-text-2)', marginBottom: 24 }}>Your password has been successfully updated. You can now sign in.</p>
            <button onClick={() => navigate('/')} className="btn-primary" style={{ width: '100%', height: 52 }}>SIGN IN</button>
          </div>
        )}
      </div>
    </div>
  );
}
